import IEqual from "component-models/src/iequal";


export default class ListViewItem<T>{
    Selected:boolean;
    Disabled:boolean;
    Value:IEqual<T>;
    constructor(value:IEqual<T>, selected:boolean, disabled:boolean){
      this.Value = value;
      this.Selected = selected;
      this.Disabled = disabled;
    }
  }


// WEBPACK FOOTER //
// ./~/ui-components/~/list-view/src/listviewitem.ts